// extracted by mini-css-extract-plugin
export default {"LangPicker":"LangPicker17mF-TSKPUmJ","LangPicker-short-label":"LangPicker-short-label2okKW5KZB-hn"};